/* eslint-disable react-refresh/only-export-components -- This adapter mirrors react-router-dom component and hook exports. */
import { forwardRef, useCallback, useMemo } from 'react';
import { Link as RouterLink, useLocation as useRouterLocation, useNavigate as useRouterNavigate, type LinkProps, type NavigateOptions, type To } from 'react-router-dom';
import { currentLanguage, tr, useStoreLanguage } from './index';
import { localizedPath, splitLocalePath } from './core';
export * from 'react-router-dom';

function localizeTo(to: To): To {
  return typeof to === 'string' ? localizedPath(to, currentLanguage())
    : to.pathname ? { ...to, pathname: localizedPath(to.pathname, currentLanguage()) } : to;
}
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function LocalizedLink(props, ref) {
  useStoreLanguage();
  return <RouterLink {...props} to={localizeTo(props.to)} title={tr(props.title)} aria-label={tr(props['aria-label'])} ref={ref} />;
});
export function useNavigate(): ReturnType<typeof useRouterNavigate> {
  const navigate = useRouterNavigate();
  return useCallback(((to: To | number, options?: NavigateOptions) => typeof to === 'number' ? navigate(to) : options ? navigate(localizeTo(to), options) : navigate(localizeTo(to))) as ReturnType<typeof useRouterNavigate>, [navigate]);
}
export function useLocation(): ReturnType<typeof useRouterLocation> {
  const location = useRouterLocation();
  return useMemo(() => ({ ...location, pathname: splitLocalePath(location.pathname).pathname }), [location]);
}
